import { createAuthenticationService } from '@best-start/beststart.react.app-switcher';
import config from '../config';
import logger from '../utils/logger';

const {
  AuthenticationService,
  AuthenticationServiceProvider,
  useAuthenticationService
} = createAuthenticationService(config, logger);

export { AuthenticationService, AuthenticationServiceProvider, useAuthenticationService };
